import Client from 'shopify-storefront-client';

export type ShopifyClientContext = {
    shopifyDomain: string;
    languageCode: string;
    countryCode: string;
    storefrontAccessToken: string;
    shopifyMarketCountryCode: string | null;
};

const getClientSettings = (context: ShopifyClientContext | null) => ({
    shop: {
        myshopify_domain: context?.shopifyDomain || 'maapapparel.myshopify.com',
        language_code: context?.languageCode || 'EN',
        country_code: context?.shopifyMarketCountryCode || 'AU',
    },
    api: {
        token:
            context?.storefrontAccessToken ||
            (process.env
                .NEXT_PUBLIC_SHOPIFY_STOREFRONT_API_ACCESS_TOKEN_INTL as string),
        version: '2026-01',
    },
});

let client: Client | null = null;
export function getClient(context: ShopifyClientContext | null): Client {
    const settings = getClientSettings(context || null);
    client = Client.fromSettings(settings);
    client.getSettings();
    return client;
}

export default getClient;
